import { Box, BoxProps } from '@chakra-ui/react';
import { ReactNode } from 'react';
import { UseQueryResult } from 'react-query';

import { Empty } from '$components/ui/empty';
import { Error } from '$components/ui/error';
import { Loading } from '$components/ui/loading';

type Query<T> = UseQueryResult<T[], unknown> & { total?: number };

interface DataListProps<T> extends BoxProps {
  query: Query<T>;
  render: (element: T) => JSX.Element;
  error: string;
  empty: string;
  beforeList?: ReactNode;
  afterList?: ReactNode;
}

export function DataList<T>({
  query,
  render,
  error,
  empty,
  beforeList,
  afterList,
  ...props
}: DataListProps<T>) {
  if (query.isLoading) return <Loading />;
  if (query.isError) return <Error message={error} />;

  const hasData = (query.data?.length || 0) > 0;
  if (!hasData) return <Empty message={empty} />;

  return (
    <Box {...props}>
      {beforeList}
      {query.data?.map(render)}
      {afterList}
    </Box>
  );
}
